"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError = void 0;
var tslib_1 = require("tslib");
var getRaygunInstance_1 = require("./getRaygunInstance");
/**
 * Sends an error to Raygun
 * @param error the error
 * @param vm the Vue component
 * @param info info from the Vue error handler
 */
function logError(error, vm, info) {
    var _a, _b;
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var customData, tags, rg4js;
        return (0, tslib_1.__generator)(this, function (_c) {
            switch (_c.label) {
                case 0:
                    customData = {
                        info: info
                    };
                    if (!vm) return [3 /*break*/, 2];
                    customData.component = {
                        name: ((_a = vm.$options) === null || _a === void 0 ? void 0 : _a.name) || "",
                        data: vm.$data || {},
                        props: vm.$props || {}
                    };
                    if (!vm["$route"]) return [3 /*break*/, 2];
                    // dynamically import if we found a route property
                    return [4 /*yield*/, Promise.resolve().then(function () { return (0, tslib_1.__importStar)(require("vue-router")); })];
                case 1:
                    // dynamically import if we found a route property
                    _c.sent();
                    customData.route = {
                        name: vm.$route.name,
                        path: vm.$route.path,
                        meta: vm.$route.meta,
                        params: vm.$route.params,
                        query: vm.$route.query,
                        fullPath: vm.$route.fullPath
                    };
                    _c.label = 2;
                case 2:
                    tags = ["vue", info];
                    if ((_b = customData.component) === null || _b === void 0 ? void 0 : _b.name) {
                        tags.push(customData.component.name);
                    }
                    rg4js = (0, getRaygunInstance_1.getRaygunInstance)();
                    // see https://raygun.com/documentation/language-guides/javascript/crash-reporting/advanced-setup/#manually-sending-errors
                    rg4js("send", {
                        error: error,
                        // see https://raygun.com/documentation/language-guides/javascript/crash-reporting/advanced-setup/#custom-data
                        customData: customData,
                        // see https://raygun.com/documentation/language-guides/javascript/crash-reporting/advanced-setup/#adding-tags
                        tags: tags
                    });
                    return [2 /*return*/];
            }
        });
    });
}
exports.logError = logError;
//# sourceMappingURL=logError.js.map